export enum UserCentricsConstants {
    INITIALIZED = 'UC_UI_INITIALIZED',
    UI_CONSENT_MANAGEMENT_PLATFORM_EVENT = 'UC_UI_CMP_EVENT',
    UI_CONSENT_SAVE = 'SAVE',
    UI_ACCEPT_ALL = 'ACCEPT_ALL',
    UI_DENY_ALL = 'DENY_ALL',
    UC_CONSENT = 'UC_CONSENT',
}

export const localStorageKey = 'ucData';
